/* eslint-disable react/prop-types */
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React, { Suspense, useEffect, useMemo } from "react";
import { BrowserRouter } from "react-router-dom";

import { useAuth } from "./Context/authContext.jsx";
import Loader from "./components/Loader/index.jsx";
import useApi from "./hooks/useApi.js";
import useListener from "./hooks/useListener.js";

const ClientRoutes = React.lazy(() => import("./client/Routes.jsx"));
const PharmacyRoutes = React.lazy(() => import("./pharmacyadmin/Routes.jsx"));
const AdminRoutes = React.lazy(() => import("./admin/Routes.jsx"));
const DoctorRoutes = React.lazy(() => import("./doctor/Routes.jsx"));

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

const App = function ({ subdomain }) {
  useListener();
  useApi();

  const routes = {
    admin: AdminRoutes,
    pharmacy: PharmacyRoutes,
    doctor: DoctorRoutes,
  };

  const Component = routes[subdomain] || ClientRoutes;
  const queryClient = useMemo(() => new QueryClient(), []);
  const { authToken, fetchData } = useAuth();

  useEffect(() => {
    if (authToken) {
      fetchData();
    }
  }, [authToken, fetchData]);

  return (
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <Elements stripe={stripePromise}>
          <Suspense fallback={<Loader />}>
            <Component />
          </Suspense>
        </Elements>
      </QueryClientProvider>
    </BrowserRouter>
  );
};

export default App;
